function GraphLegend({ stats }) {
  return (
    <div className="flex flex-wrap items-center gap-6 p-4 bg-white rounded-lg border border-gray-200">
      {stats?.tipologieCount > 0 && (
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-purple-500"></div>
          <span className="text-sm text-gray-700">Tipologie</span>
          <span className="text-sm font-semibold text-gray-900">({stats.tipologieCount})</span>
        </div>
      )}

      <div className="flex items-center gap-2">
        <div className="w-4 h-4 rounded bg-green-500"></div>
        <span className="text-sm text-gray-700">Fornitori</span>
        {stats?.fornitoriCount !== undefined && (
          <span className="text-sm font-semibold text-gray-900">({stats.fornitoriCount})</span>
        )}
      </div>

      <div className="flex items-center gap-2">
        <div className="w-4 h-4 rounded bg-blue-500"></div>
        <span className="text-sm text-gray-700">RSA</span>
        {stats?.rsaCount !== undefined && (
          <span className="text-sm font-semibold text-gray-900">({stats.rsaCount})</span>
        )}
      </div>

      <div className="flex items-center gap-2">
        <div className="w-8 h-0.5 bg-gray-400"></div>
        <span className="text-sm text-gray-700">Relazioni</span>
        {stats?.edgeCount !== undefined && (
          <span className="text-sm font-semibold text-gray-900">({stats.edgeCount})</span>
        )}
      </div>

      <div className="ml-auto text-xs text-gray-500">
        Click su un nodo per evidenziare le connessioni | Doppio click per dettaglio
      </div>
    </div>
  );
}

export default GraphLegend;
